import React from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { useToaster } from "../../../Toaster/Toaster";
interface ConfirmationProps {
  onClose: () => void;
  onConfirm: () => void;
 title:string;
 body:string;
 confirmButtonName:string;
 closeButtonName:string;
}
const DynamicTextPopup: React.FC<ConfirmationProps> = ({
  onClose,
  onConfirm,
  title,
  body,
  confirmButtonName,
  closeButtonName,
  
}) => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden sm:w-1/3 md:w-1/3 w-10/12">
        <div className="p-4">
          <div className="flex items-center justify-center">
            <div className="ml-4">
                <h3 className="text-lg font-medium text-gray-900 text-center">
                 {title}
                </h3>
                <p className="text-base text-gray-500 text-center mt-4">
                 {body}
                </p>
              
            </div>
          </div>
        </div>
        <div
          className="bg-white px-4 py-3 sm:px-6 sm:flex justify-center sm:flex-row-revers"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
          <button
            type="button"
            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
            onClick={onClose}
          >
            {closeButtonName}
          </button>
          
         

        
            <>
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2"
                onClick={onConfirm}
              >
               {confirmButtonName}
              </button>
            </>
        </div>
      </div>
    </div>,
    document.body
  );
};


export default DynamicTextPopup
